<template>
  <div class="type-tree">
    <div class="search" v-if="isSearch">
      <el-input
        class="gray white"
        :placeholder="title"
        prefix-icon="el-icon-search"
        v-model="filterText"
        clearable
      >
      </el-input>
    </div>
    <el-tree
      ref="tree"
      node-key="id"
      :filter-node-method="filterNode"
      :data="list"
      :props="defaultProps"
      :highlight-current="true"
      :default-expanded-keys="[id]"
      :current-node-key="id"
      :expand-on-click-node="false"
      @node-click="handleNodeClick"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="tree-label">
          <span v-if="data.children" class="iconfont" style="margin-right: 16px">
            <img :src="data.img">
          </span>
          <span v-else class="children-img" style="margin-right: 16px">
            <img :src="data.img">
          </span> 
          
          <el-tooltip v-if="node.label.length > 7" class="item" effect="dark" :content="node.label" placement="top">
            <span>{{ node.label}}</span>
          </el-tooltip>
          <span v-else>{{ node.label}}</span>
        </span>
        <span class="el-dropdown-link threeSpotImg" v-if="type == 4">
          <span class="system-preset" v-if="data.officialType == 1 && data.level === 2">系统预设</span>
        </span>
        <span class="threeSpotImg" v-if="type !== 3 && type !== 4">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link threeSpotImg">
              <span class="system-preset" v-if="data.officialType == 1 && data.level === 2">系统预设</span>
              <img  v-if="data.officialType != 1" :src="data.threeSpotImg">
            </span>
            <el-dropdown-menu slot="dropdown">
              <div v-if="data.officialType != 1">
                <el-dropdown-item :command="beforeHandleCommand(data, 'preliminaryAddType')" v-if="data.level === 1 && type === 2&&OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddPreApprovalType
              ) !== -1">新增分类</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'preliminaryModType')" v-if="type === 2 && data.level == 2">重命名</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'preliminaryAddBill')" v-if="type === 2 && data.level == 2&&OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddPreApprovalType
              ) !== -1">新增单据</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'reimbursemnetAddBill')" v-if="data.level == 1 && type === 1&&OPERATION_LIST.findIndex(
                (item) => item === OPERATIONS_BTNS.roleAddReimburseForm
              ) !== -1">添加单据</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'del')" v-if="data.children.length === 0 && type === 2&& data.level == 3" style="color: #F55545;">删除</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'delPreliminaryType')" v-if="data.children.length === 0 && type === 2 && data.level == 2" style="color: #F55545;">删除</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(data, 'reimbursemnetDel')" v-if="data.level === 2 && type === 1" style="color: #F55545;">删除</el-dropdown-item>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
        </span>     
      </span>
    </el-tree>
  </div>
</template>

<script>
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  props: {
    listId: {
      type: Number
    },
    list: {
      type: Array
    },
    /* 1: 报销类型; 2：预审批类型; 3：费用类型 */
    type: {
      type: Number
    },
    title: {
      type: String,
      default: '输入搜索内容'
    },
    isSearch: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      defaultProps: {
        children: "children",
        label: "label"
      },
      filterText: '',
      id: this.listId,
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },

  created() {
  },
  

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    
    /* 点击变更部门 */
    handleNodeClick(data) {
      this.id = Number(data.id);
      this.$emit('selectTreeNodeList', data)
    },


    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command){
      return {
        'value': value,
        'command':command
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "preliminaryAddType":
          this.$emit('openPreliminaryAddType', command.value)
          break;
        case "preliminaryModType":
          this.$emit('openPreliminaryModType', command.value)
          break;
        case "preliminaryAddBill":
          this.$emit('openPreliminaryAddBill', command.value)
          break;
        case "reimbursemnetAddBill":
          this.$emit('openReimbursemnetAddBill', command.value)
          break;
        case "del":
          this.$emit('del', command.value)
          break;
        case "delPreliminaryType":
          this.$emit('delPreliminaryType', command.value)
          break;
        case "reimbursemnetDel":
          this.$emit('reimbursemnetDel', command.value)
          break;
      }
    },
  }
}
</script>

<style lang='scss'>
.type-tree {
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $bg-ChangeDepartmentHighTree;
    color: $color-ChangeDepartmentHighTree;
  }
  .el-tree-node__content {
    height: 40px;
    line-height: 40px;
    font-size: $fs-small-l;
    color: $color-grey;
  }
  .tree-label {
    width: 136px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .search {
    margin-bottom: 12px;
    .el-input__prefix, .el-input__suffix {
      top: 2px;
    }
  }
  .system-preset {
    color: $color-ChangeDepartmentHighTree;
  }
  .custom-tree-node {
    width: 100%;
    @include flex-between;
    padding-right: 20px;
    .threeSpotImg {
      @include extend-click;
    }
  }
}
</style>
